// extracted by mini-css-extract-plugin
export default {"homepageContainer":"HomePage_homepageContainer__VRySi","homepageImage":"HomePage_homepageImage__W43W6"};